import {
  EventType,
  ICreateRoomStateEvent,
  JoinRule,
  MatrixClient,
  RestrictedAllowType,
} from 'matrix-js-sdk/src/matrix';

export const buildMessengerRoomRestrictedState = (messengerRoomId: string): ICreateRoomStateEvent => ({
  type: EventType.RoomJoinRules,
  state_key: '',
  content: {
    join_rule: JoinRule.Restricted,
    allow: [{ type: RestrictedAllowType.RoomMembership, room_id: messengerRoomId }],
  },
});

export const applyMessengerRestrictedJoin = async (
  matrixClient: MatrixClient,
  meetingRoomId: string,
  messengerRoomId: string
): Promise<void> => {
  await matrixClient.sendStateEvent(
    meetingRoomId,
    EventType.RoomJoinRules,
    {
      join_rule: JoinRule.Restricted,
      allow: [{ type: RestrictedAllowType.RoomMembership, room_id: messengerRoomId }],
    },
    ''
  );
};
